import { extendTheme } from "@chakra-ui/react";

const darkTheme = extendTheme({
  fonts: {
    body: '"Raleway", system-ui, sans-serif',
    heading: '"Orbitron", system-ui, sans-serif',
  },
  colors: {
    primary: {
      50: "#e6e6e6",
      100: "#b8b8c2",
      200: "#8a8a99",
      300: "#5c5c6e",
      400: "#3f3f4a",
      500: "#171730",
      600: "#121220",
      700: "#0d0d15",
      800: "#08080b",
      900: "#040405",
      accent: "#0ff", // Cyan for a neon effect
    },
    secondary: {
      50: "#f2f2f2",
      100: "#d1d1d1",
      200: "#a9a9a9",
      300: "#787878",
      400: "#515151",
      500: "#353535",
      600: "#2c2c2c",
      700: "#1f1f1f",
      800: "#151515",
      900: "#0a0a0a",
    },
    cyberpunk: {
      pink: "#ff69b4",
      purple: "#9a03fe",
      green: "#39ff14",
    },
  },
  config: {
    initialColorMode: "dark",
    useSystemColorMode: false,
  },
  components: {
    Button: {
      baseStyle: {
        fontWeight: "500",
        transition: "all 0.3s ease", // Smooth transition for hover and active states
      },
      variants: {
        solid: (props: { colorMode: string }) => ({
          bg:
            props.colorMode === "dark"
              ? "linear-gradient(to top, #2c2c2c, #515151)"
              : "primary.500",
          color: props.colorMode === "dark" ? "primary.accent" : "white",
          _hover: {
            bg: props.colorMode === "dark" ? "secondary.600" : "primary.400",
            boxShadow:
              props.colorMode === "dark" ? "0px 0px 15px #0ff" : "0px 0px 10px rgba(0, 0, 0, 0.5)",
          },
          _active: {
            boxShadow: "none",
          },
        }),
        connectWithStrava: {
          bg: "transparent", // Override background
          color: "inherit", // Use inherited color
          border: "none", // No border
          padding: 0, // No padding
          height: "auto", // Auto height to adjust based on content
          minWidth: "auto", // Auto width to adjust based on content
          _hover: {
            bg: "transparent", // Keep background transparent on hover
          },
          _active: {
            bg: "transparent", // Keep background transparent on active
          },
          _focus: {
            boxShadow: "none", // Remove focus outline or box-shadow
          },
        },
        compatibleWithStrava: {
          bg: "transparent", // Override background
          color: "inherit", // Use inherited color
          border: "none", // No border
          padding: 0, // No padding
          margin: 0, // No margin
          // height: "auto", // Auto height to adjust based on content
          minWidth: "auto", // Auto width to adjust based on content
          _hover: {
            bg: "transparent", // Keep background transparent on hover
          },
          _active: {
            bg: "transparent", // Keep background transparent on active
          },
          _focus: {
            boxShadow: "none", // Remove focus outline or box-shadow
          },
        },
      },
    },
    Link: {
      baseStyle: (props: { colorMode: string }) => ({
        color: props.colorMode === "dark" ? "primary.accent" : "primary.500",
        _hover: {
          textDecoration: "underline",
          color: props.colorMode === "dark" ? "primary.200" : "primary.400",
        },
      }),
    },
    Box: {
      variants: {
        glass: (props: { colorMode: string }) => ({
          bg: props.colorMode === "dark" ? "rgba(255, 255, 255, 0.1)" : "rgba(0, 0, 0, 0.1)",
          backdropFilter: "blur(5px)",
          borderRadius: "10px",
          p: 4,
          shadow: "md",
        }),
        nav: (props: { colorMode: string }) => ({
          bg: props.colorMode === "dark" ? "primary.700" : "white",
          p: 4,
          shadow: "md",
        }),
      },
    },
  },
  styles: {
    global: {
      body: {
        bg: "secondary.800",
        color: "primary.100",
        fontFamily: '"Raleway", system-ui, sans-serif', // Ensure this matches your theme's fonts
        overflowX: "hidden", // Ensures no horizontal scroll
        transition: "background 0.3s ease",
      },
      a: {
        textDecoration: "none",
        color: "inherit",
        _hover: {
          textDecoration: "underline",
        },
      },
      "#content-container": {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        textAlign: "center",
        padding: "0 20px", // Adds a little padding on the sides for small screens
      },
    },
  },
});

export default darkTheme;
